export const FETCH_YARD_DEVICES_SUCCESS = "FETCH_YARD_DEVICES_SUCCESS";
export const ADD_YARD_DEVICE_SUCCESS = "ADD_YARD_DEVICE_SUCCESS";
export const MOVE_YARD_DEVICE_SUCCESS = "MOVE_YARD_DEVICE_SUCCESS";
export const REMOVE_YARD_DEVICE_SUCCESS = "REMOVE_YARD_DEVICE_SUCCESS";
